const PALETTE = [
  { backgroundColor: '#e8d5c4', color: '#6b3a1f' },
  { backgroundColor: '#d5e0d5', color: '#2d4a2d' },
  { backgroundColor: '#d5dae8', color: '#2d3a5c' },
  { backgroundColor: '#e8d5e0', color: '#5c2d4a' },
  { backgroundColor: '#dde8d5', color: '#3a5c2d' },
  { backgroundColor: '#e0d5e8', color: '#4a2d5c' },
  { backgroundColor: '#d5e8e0', color: '#2d5c4a' },
  { backgroundColor: '#e8e0d5', color: '#5c4a2d' },
]

function hashName(name) {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash += name.charCodeAt(i)
  return hash
}

export function getInitials(name) {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  const first = parts[0]?.[0] || ''
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase() || '?'
}

export function getAvatarStyle(name) {
  if (!name) return PALETTE[0]
  return PALETTE[hashName(name) % PALETTE.length]
}
